<template>
  <div class="lift-step-four">
    <v-layout>
      <v-flex sm6>
        <v-switch
          v-model="form.tablet_module.idc_tablet"
          hide-details
          label="Tablette :"
          class="title"
          @change="clearTabletFields"
        />
        <v-radio-group
          v-model="form.tablet_module.type"
          hide-details
          row
          class="mb-4"
          :disabled="!form.tablet_module.idc_tablet"
        >
          <v-radio
            label="Existant"
            value="EXISTING"
          />
          <v-radio
            label="Sur mesure"
            value="CUSTOM_MADE"
          />
        </v-radio-group>

        <v-layout wrap>
          <v-radio-group
            v-model="form.tablet_module.matter"
            hide-details
            row
            class="mb-4"
            :disabled="!form.tablet_module.idc_tablet"
          >
            <v-radio
              label="Plexi"
              value="PLEXI"
            />
            <v-radio
              label="PVC"
              value="PVC"
            />
          </v-radio-group>
          <v-checkbox
            v-model="form.tablet_module.idc_standard"
            hide-details
            label="Standard"
            class="mr-4 mt-2"
            :disabled="!form.tablet_module.idc_tablet"
          />
          <v-radio-group
            v-model="form.tablet_module.tablet_type"
            hide-details
            row
            class="mb-4"
            :disabled="!form.tablet_module.idc_tablet"
          >
            <v-radio
              label="Bugle"
              value="BUGLE"
            />
            <v-radio
              label="Insert central"
              value="INSERT_CENTRAL"
            />
          </v-radio-group>
        </v-layout>

        <h4 class="mt-8">
          RETOUR :
        </h4>
        <v-radio-group
          v-model="form.tablet_module.comeback"
          row
          :disabled="!form.tablet_module.idc_tablet"
        >
          <v-radio
            label="Total"
            value="TOTAL"
          />
          <v-radio
            label="Sans retour"
            value="NO_RETURN"
          />
          <v-radio
            label="Coude libre"
            value="FREE_ELBOW"
          />
        </v-radio-group>
      </v-flex>

      <v-flex
        column
        sm6
      >
        <div class="content img1">
          <div class="img-container">
            <img src="@/assets/img/schema_verticalisateur_4a.svg">
            <v-text-field
              v-model="form.tablet_module.a"
              v-validate="'numeric|max:4'"
              data-vv-name="(Tablette) Schema A"
              :class="{ error: errors.has('(Tablette) Schema A') }"
              type="number"
              style="top: -0.2%;left: 54.2%;"
              height="100%"
              :disabled="!form.tablet_module.idc_tablet"
              outlined
            />
            <v-text-field
              v-model="form.tablet_module.b"
              v-validate="'numeric|max:4'"
              data-vv-name="(Tablette) Schema B"
              :class="{ error: errors.has('(Tablette) Schema B') }"
              type="number"
              style="top: 38.1%;left: 44.1%;"
              height="100%"
              :disabled="!form.tablet_module.idc_tablet"
              outlined
            />
            <v-text-field
              v-model="form.tablet_module.c"
              v-validate="'numeric|max:4'"
              data-vv-name="(Tablette) Schema C"
              :class="{ error: errors.has('(Tablette) Schema C') }"
              type="number"
              style="top: 65.4%;left: 28.4%;"
              height="100%"
              :disabled="!form.tablet_module.idc_tablet"
              outlined
            />
            <v-text-field
              v-model="form.tablet_module.d"
              v-validate="'numeric|max:4'"
              data-vv-name="(Tablette) Schema D"
              :class="{ error: errors.has('(Tablette) Schema D') }"
              type="number"
              style="top: 86.4%;left: 54.2%;"
              height="100%"
              :disabled="!form.tablet_module.idc_tablet"
              outlined
            />
            <v-text-field
              v-model="form.tablet_module.e"
              v-validate="'numeric|max:4'"
              data-vv-name="(Tablette) Schema E"
              :class="{ error: errors.has('(Tablette) Schema E') }"
              type="number"
              style="top: 65.4%;left: 81.1%;"
              height="100%"
              :disabled="!form.tablet_module.idc_tablet"
              outlined
            />
            <v-text-field
              v-model="form.tablet_module.f"
              v-validate="'numeric|max:4'"
              data-vv-name="(Tablette) Schema F"
              :class="{ error: errors.has('(Tablette) Schema F') }"
              type="number"
              style="top: 61.6%;left: 0.1%;"
              height="100%"
              :disabled="!form.tablet_module.idc_tablet"
              outlined
            />
          </div>
        </div>
      </v-flex>
    </v-layout>
    <v-textarea
      v-model="form.tablet_comment"
      filled
      name="Ajouter un commentaires :"
      label="Ajouter un commentaires :"
      :disabled="!form.tablet_module.idc_tablet"
    />
  </div>
</template>

<script>
export default {
  name: "LiftStepFour",
  inject: ["parentValidator"],
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  created() {
    this.$validator = this.parentValidator;
  },
  methods: {
    // Clear tablet fields
    clearTabletFields() {
      this.form.tablet_module.type = null;
      this.form.tablet_module.idc_standard = false;
      this.form.tablet_module.matter = null;
      this.form.tablet_module.tablet_type = null;
      this.form.tablet_module.comeback = null;
      this.form.tablet_module.a = null;
      this.form.tablet_module.b = null;
      this.form.tablet_module.c = null;
      this.form.tablet_module.d = null;
      this.form.tablet_module.e = null;
      this.form.tablet_module.f = null;
    }
  }
};
</script>

<style lang="scss">
.lift-step-four {
  .content {
    display: flex;
    //min-height: 80vh;
    .img-container {
      position: relative;
      display: inline-block;
      margin: auto;
      img {
        //height: 100%;
        //width: 100%;
        //min-width: 800px;
        @media (max-width: 800px) {
          min-width: auto;
        }
      }
      .v-input {
        position: absolute;
        width: 12.1%;
        height: 11.3%;
        @media (max-width: 800px) {
          height: 11.3%;
        }
        .v-input__control {
          height: 100%;
          .v-input__slot {
            min-height: auto;
          }
        }
      }
    }
  }
}
</style>
